import React from 'react';

import { Button, ButtonGroup, IconButton, useMediaQuery } from '@material-ui/core';
import NextIcon from '@material-ui/icons/SkipNext';
import PreviousIcon from '@material-ui/icons/SkipPrevious';

import { ExerciseFileTypes } from 'api/rest/exercises/exercises.types';
import ExerciseViewTile from 'components/ExerciseViewTile/ExerciseViewTile';
import { Id } from 'types/Id';
import ExercisesName from 'uniqueComponents/Exercises/ExercisesName/ExercisesName';
import ExercisesPagination from 'uniqueComponents/Exercises/ExercisesPagination/ExercisesPagination';

import useStyles from './ExercisesNavigation.styles';

type Props = {
  isStuck?: boolean;
  exerciseName: string;
  actions: {
    fileTypeChange: (newType: ExerciseFileTypes) => () => void;
    onNext: () => void;
    onPrevious: () => void;
  };
  buttonsEnableState: {
    hint: boolean;
    previous: boolean;
    next: boolean;
    answer: boolean;
    question: boolean;
  };
  fileType: ExerciseFileTypes;
  exercisesCursor: number;
  exercisesCount: number;
  isMarked: boolean;
  currentExerciseId?: Id | null;
  dataSource?: 'common_store';
};

const ExercisesNavigation: React.FC<Props> = ({
  isStuck,
  buttonsEnableState,
  actions,
  exerciseName,
  fileType,
  exercisesCursor,
  exercisesCount,
  isMarked,
  currentExerciseId,
  dataSource,
}) => {
  const downMd = useMediaQuery('(max-width: 1080px)');

  const setAnswerType = actions.fileTypeChange(ExerciseFileTypes.answer);
  const setHintType = actions.fileTypeChange(ExerciseFileTypes.hint);
  const setQuestionType = actions.fileTypeChange(ExerciseFileTypes.question);

  const classes = useStyles({ isStuck: !!isStuck });
  return (
    <ExerciseViewTile className={classes.tile}>
      <>
        <div className={classes.top}>
          <div className={classes.navigationButtons}>
            <IconButton size='small' disabled={!buttonsEnableState.previous} onClick={actions.onPrevious}>
              <PreviousIcon fontSize='small' color={buttonsEnableState.previous ? 'primary' : 'disabled'} />
            </IconButton>
            <ExercisesPagination exerciseCursor={exercisesCursor} total={exercisesCount} />
            <IconButton size='small' disabled={!buttonsEnableState.next} onClick={actions.onNext}>
              <NextIcon fontSize='small' color={buttonsEnableState.next ? 'primary' : 'disabled'} />
            </IconButton>
          </div>
          <ExercisesName
            cacheStrategy={dataSource === 'common_store' ? 'rq' : 'apollo'}
            currentExerciseId={currentExerciseId}
            isMarked={isMarked}
            name={exerciseName}
          />
        </div>
        <nav className={classes.fileTypeSelector}>
          <ButtonGroup aria-label='Treść, podpowiedź lub odpowiedź' className={classes.fileTypeButtonGroup} color='primary' size='small'>
            <Button
              className={classes.fileTypeButton}
              disabled={!buttonsEnableState.question}
              onClick={setQuestionType}
              variant={fileType === ExerciseFileTypes.question ? 'contained' : 'outlined'}
            >
              Treść
            </Button>
            <Button
              className={classes.fileTypeButton}
              disabled={!buttonsEnableState.hint}
              onClick={setHintType}
              variant={fileType === ExerciseFileTypes.hint ? 'contained' : 'outlined'}
            >
              {downMd ? 'Podp.' : 'Podpowiedź'}
            </Button>
            <Button
              className={classes.fileTypeButton}
              disabled={!buttonsEnableState.answer}
              onClick={setAnswerType}
              variant={fileType === ExerciseFileTypes.answer ? 'contained' : 'outlined'}
            >
              {downMd ? 'Odp.' : 'Odpowiedź'}
            </Button>
          </ButtonGroup>
        </nav>
      </>
    </ExerciseViewTile>
  );
};

ExercisesNavigation.defaultProps = {
  isStuck: false,
};

export default ExercisesNavigation;
